<template>
  <section>
    <header>
      <h3
        :class="[
          $style.headerText,
          $style.headerTextTable
        ]"
      >
        {{ control.label }}
      </h3>
      <IconTooltip
        v-if="tableTooltip && tableTooltip.text"
        :iconClass="['jc-info-circle']"
      >
        <!-- eslint-disable vue/no-v-html -->
        <p
          v-html="tableTooltip.text"
        />
        <!-- eslint-enable vue/no-v-html -->
      </IconTooltip>
    </header>
    <table :class="$style.controlTable">
      <thead>
        <tr>
          <th
            v-for="componentSchema in getTableSchema()"
            :key="componentSchema.name"
            :class="$style.tableHeader"
          >
            {{ componentSchema.label }}
            <IconTooltip
              v-if="componentSchema.tooltip && componentSchema.tooltip.variables"
              :iconClass="['jc-info-circle']"
            >
              <!-- DO NOT ALLOW ANY USER INPUT IN STRING PASSED TO v-html -->
              <!-- eslint-disable vue/no-v-html -->
              <p
                v-html="componentSchema.tooltip.variables.message"
              />
              <!-- eslint-enable vue/no-v-html -->
            </IconTooltip>
          </th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(rowItems, index) in value"
          :key="rowItems._id || rowItems.tempId"
        >
          <td
            v-for="control in headerlessTableSchema"
            :key="control._id"
            :class="$style.tableCell"
          >
            <TableDynamicFields
              :index="index"
              :itemSchema="control"
              :rowItem="rowItems"
              @fieldChange="handleChangeTableRow"
            />
          </td>

          <td>
            <button
              :class="[
                $style.removeButton,
                $style.removeButtonTable
              ]"
              @click="handleRemoveTableRow(index)"
            >
              <i
                :class="[
                  $style.removeButtonIcon,
                  'jc-actions-trash']"
              />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <FlatActionButton
      :action="handleAddTableRow"
      :text="buttonText"
    />
  </section>
</template>

<script>
// v-html is coming from BE, it should assumed that it is properly sanitized before being displayed

import { clone, cloneDeep } from 'lodash';
import DynamicControlsMixin from 'client/components/DynamicControls/mixins/DynamicControlsMixin';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';
import IconTooltip from 'client/components/Tooltip/IconTooltip';
import TableDynamicFields from 'client/components/DynamicControls/BodyComponents/TableDynamicFields';

export default {
  name: 'DynamicControlsTable',

  components: {
    TableDynamicFields,
    IconTooltip,
    FlatActionButton,
  },

  mixins: [
    DynamicControlsMixin,
  ],

  props: {
    value: {
      default: () => [],
      type: Array,
    },
  },

  data() {
    return {
      tableTooltip: {},
      headerlessTableSchema: [],
      defaultValues: cloneDeep(this.control.defaultValue[0]),
    };
  },

  inject: ['$validator'],

  computed: {
    buttonText(state) {
      const { buttonText, displayOptions } = state.control;
      const defaultText = 'add new custom attribute';

      return (displayOptions && displayOptions.buttonText) || buttonText || defaultText;
    },
  },

  created() {
    this.tableTooltip = this.getTooltip();
    this.headerlessTableSchema = this.getUpdatedTableSchema();
  },

  methods: {
    getTableSchema() {
      return this.control.displayOptions.TABLE;
    },

    getUpdatedTableSchema() {
      const updatedSchema = cloneDeep(this.control.displayOptions.TABLE);
      return updatedSchema.map((column) => {
        const updatedColumn = column;
        updatedColumn.label = '';
        updatedColumn.tooltip = '';
        return updatedColumn;
      });
    },

    handleAddTableRow() {
      const clonedValues = clone(this.value);
      clonedValues.push(cloneDeep(this.defaultValues));
      this.handleValueChange(this.control.id, clonedValues);
    },

    handleChangeTableRow(index, rowValues) {
      const clonedValues = clone(this.value);
      clonedValues[index] = rowValues;
      this.handleValueChange(this.control.id, clonedValues);
    },

    handleRemoveTableRow(index) {
      const clonedValues = clone(this.value);
      clonedValues.splice(index, 1);
      this.handleValueChange(this.control.id, clonedValues);
    },
  },
};
</script>

<style module scoped>

  @import '../../FormValidation/css/ListEditor.css';

  .headerTextTable {
    margin: 0 0 10px !important;
  }

  .removeButtonTable {
    background: none;
    padding: 0 0 15px;
    position: unset;
  }

  .controlTable {
    width: 100%;
  }

  .tableCell {
    margin-right: 5px;
  }

  .tableHeader {
    padding-right: 10px;
    white-space: nowrap;
  }
</style>
